export const EVENTS = {
  CLICK_ABOUT: 'Click About',
  CLICK_ACTION_CARD: 'Click Action Card',
  CLICK_CONTACT_LINK: 'Click Contact Link',
  CLICK_MORE_ITEMS: 'Click More Items',
  CLICK_SOURCE_ARTICLE: 'Click Source Article',
  CLICK_TAKE_ACTION: 'Click Take Action',
  REDIRECT_TO_TRUMPISM: 'Redirect to Trumpism',
  CLICK_HEADER_LINK: 'Click Header Link'
};

export const SOURCES = {
  ABOUT: 'About',
  HEADER: 'Header',
  HOMEPAGE: 'Homepage',
  TAKE_ACTION: 'Take Action',
  TRUMPISM: 'Trumpism'
};



// WEBPACK FOOTER //
// ./src/services/analytics-constants.js